<template>
    <div>
        <main role="main">
            <div class="container">
                <loading
                        :active.sync="isLoading"
                        :can-cancel="false"
                        :is-full-page="false"
                ></loading>

                <div class="row">
                    <div class="col-md-12">
                        <h2 class="mb-3">
                            <i class="fa fa-check"></i> {{$t('text.rocniVnosStatusaPrevzemaPaketa.title')}}
                        </h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">

                        <div class="table-responsive">
                            <table class="table searchResults table-hover" v-if="packages.length > 0">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{{$t('text.globals.description')}}</th>
                                    <th>{{$t('text.rocniVnosStatusaPrevzemaPaketa.fileNumber')}}</th>
                                    <th>{{$t('text.globals.date')}}</th>
                                    <th>{{$t('text.rocniVnosStatusaPrevzemaPaketa.createdBy')}}</th>
                                    <th class="text-center">{{$t('text.globals.status')}}</th>
                                    <th style="width: 280px;">{{$t('text.globals.actions')}}</th>
                                </tr>
                                </thead>
                                <tbody>

                                <tr v-for="(item,index) in packages" :key="index">
                                    <td class="align-middle">{{index+1}}</td>
                                    <td class="align-middle">
                                        <div v-if="item.description">
                                            <span style="overflow: hidden; text-overflow: ellipsis; display: inline-block; max-width: 70ch; white-space: nowrap; position: relative;">{{item.description}}</span>
                                            <i class="fa fa-info-circle" style="position:absolute; margin-top: 3px; margin-left: 5px;" v-if="item.description.length >= 67" v-b-tooltip.hover :title="item.description"></i>
                                        </div>
                                        <div v-if="!item.description">
                                            <em class="text-muted">{{$t('text.rocniVnosStatusaPrevzemaPaketa.noDescription')}}</em>
                                        </div>
                                    </td>
                                    <td>{{item.numFiles}}</td>
                                    <td class="align-middle">{{moment(item.creationDate).local().format('DD.MM.YYYY HH:mm')}}
                                    </td>
                                    <td class="align-middle">
                                        {{item.createdBy}}
                                    </td>
                                    <td class="align-middle text-center">
                                        <i class="fa fa-2x" :class="item.accepted ? 'text-success fa-check-circle' : 'text-muted fa-circle'"></i>
                                    </td>
                                    <td class="align-middle">
                                        <div v-if="item.accepted" class="text-center text-muted">
                                            <em>{{$t('text.rocniVnosStatusaPrevzemaPaketa.packageWasAccepted')}}</em>
                                        </div>
                                        <div v-if="!item.accepted">
                                        <a class="btn btn-sm btn-success text-white" @click="onBeforeConfirm(item)"><i
                                                class="fa fa-check"></i> {{$t('text.globals.confirm')}}</a>
                                        <a class="btn btn-sm btn-danger text-white" @click="onBeforeReject(item)"><i
                                                class="fa fa-times"></i> {{$t('text.globals.reject')}}</a>
                                        <a class="btn btn-sm btn-primary text-white ml-3" @click="onDownload(item)"><i
                                                class="fa fa-download"></i> {{$t('text.globals.download')}}</a>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script type="text/javascript">
    import Vue from "vue";
    import axios from "axios";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";

    export default {
        name: "RocniVnosStatusaPrevzemaPaketa",
        components: {
            Loading,
            vSelect
        },

        data() {
            return {
                packages: [],
                isLoading: false
            };
        },

        computed: {},

        mounted() {
            const _this = this;

            _this.retrievePackages();
        },

        methods: {

            retrievePackages() {
                const _this = this;

                _this.isLoading = true;
                axios
                    .get(config.rootEhramba + "archiveExportList")
                    .then((res) => {
                        _this.packages = _.sortBy(res.data.items, 'creationDate').reverse();
                        _this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        _this.isLoading = false;
                    });
            },

            onBeforeConfirm(item) {
                const _this = this;
                console.log("item", item);

                this.$swal({
                    title: this.$t('text.globals.warningTitle'),
                    text: this.$t('text.rocniVnosStatusaPrevzemaPaketa.confirmPackageSwal.prompt') + ": " + item.description + "?",
                    icon: 'info',
                    dangerMode: false,
                    buttons: {
                        cancel: {
                            text:this.$t('text.globals.cancel'),
                            value: null,
                            visible: true,
                            className: "",
                            closeModal: true,
                        },
                        confirm: {
                            text: this.$t('text.rocniVnosStatusaPrevzemaPaketa.confirmPackageSwal.confirmPackage'),
                            value: true,
                            visible: true,
                            className: "",
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.onConfirm(item);

                            case null:

                                return;

                                break;

                            default:

                        }
                    });
            },

            onConfirm(item) {
                const _this = this;
                console.log("item", item);

                _this.isLoading = true;
                axios
                    .post(config.rootEhramba + "archiveExportConfirm", {'packageUuid': item.uuid})
                    .then((res) => {
                        _this.isLoading = false;
                        _this.retrievePackages();

                        Vue.$toast.open({
                            message: this.$t('text.rocniVnosStatusaPrevzemaPaketa.packageConfirmedSuccessToast'),
                            type: 'success',
                            position: 'top-right'
                        });

                    })
                    .catch((error) => {
                        console.error(error);
                        _this.isLoading = false;

                        Vue.$toast.open({
                            message: this.$t('text.rocniVnosStatusaPrevzemaPaketa.packageConfirmedErrorToast'),
                            type: 'error',
                            position: 'top-right'
                        });
                    });
            },

            onBeforeReject(item) {
                const _this = this;
                console.log("item", item);


                this.$swal({
                    title: this.$t('text.globals.warningTitle'),
                    text: this.$t('text.rocniVnosStatusaPrevzemaPaketa.rejectPackageSwal.prompt') + ": " + item.description + "?",
                    icon: 'warning',
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            text: this.$t('text.globals.cancel'),
                            value: null,
                            visible: true,
                            className: "",
                            closeModal: true,
                        },
                        confirm: {
                            text: this.$t('text.rocniVnosStatusaPrevzemaPaketa.rejectPackageSwal.rejectPackage'),
                            value: true,
                            visible: true,
                            className: "",
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.onReject(item);

                            case null:

                                return;

                                break;

                            default:

                        }
                    });
            },

            onReject(item) {
                const _this = this;
                console.log("item", item);

                //archiveExportDelete
                _this.isLoading = true;
                axios
                    .post(config.rootEhramba + "archiveExportDelete", {'packageUuid': item.uuid})
                    .then((res) => {
                        _this.isLoading = false;
                        _this.retrievePackages();

                        Vue.$toast.open({
                            message: this.$t('text.rocniVnosStatusaPrevzemaPaketa.packageRejectedSuccessToast'),
                            type: 'success',
                            position: 'top-right'
                        });

                    })
                    .catch((error) => {
                        console.error(error);
                        _this.isLoading = false;

                        Vue.$toast.open({
                            message: this.$t('text.rocniVnosStatusaPrevzemaPaketa.packageRejectedErrorToast'),
                            type: 'error',
                            position: 'top-right'
                        });
                    });
            },

            onDownload(item) {
                const _this = this;
                console.log("item", item);

                axios
                    .post(config.rootEhramba + "archiveExportRedownload", {'packageUuid': item.uuid}, {
                        responseType: 'blob' //Force to receive data in a Blob Format
                    })
                    .then((res) => {
                        _this.isLoading = false;

                        let headerLine = res.headers['content-disposition']
                        let startFileNameIndex = headerLine.indexOf('"') + 1
                        let endFileNameIndex = headerLine.lastIndexOf('"')
                        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex)

                        console.log("res", res);

                        const url = window.URL.createObjectURL(_this.$globalFunctions.blobToFile(res.data, filename));
                        const link = document.createElement('a');

                        link.href = url;
                        link.setAttribute('download', filename);
                        link.setAttribute('type', 'application/zip');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                    })
                    .catch((error) => {
                        console.error(error);
                        _this.isLoading = false;

                        Vue.$toast.open({
                            message: this.$t('text.rocniVnosStatusaPrevzemaPaketa.packageDownloadErrorToast'),
                            type: 'error',
                            position: 'top-right'
                        });
                    });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/RocniVnosStatusaPrevzemaPaketa.vue